import {
  GET_CUSTOMER_CODES_FAILURE,
  GET_CUSTOMER_CODES_REQUEST,
  GET_CUSTOMER_CODES_SUCCESS,
  GET_PERMISSIONS_FAILURE,
  GET_PERMISSIONS_REQUEST,
  GET_PERMISSIONS_SUCCESS,
  GET_REFERENCE_NO_OPTIONS_FAILURE,
  GET_REFERENCE_NO_OPTIONS_REQUEST,
  GET_REFERENCE_NO_OPTIONS_SUCCESS,
  GET_REFERENCES_FAILURE,
  GET_REFERENCES_REQUEST,
  GET_REFERENCES_SUCCESS,
  GET_SERVICE_TYPE_LOOKUP_FAILURE,
  GET_SERVICE_TYPE_LOOKUP_REQUEST,
  GET_SERVICE_TYPE_LOOKUP_SUCCESS,
  GET_VENDORS_LIST_FAILURE,
  GET_VENDORS_LIST_REQUEST,
  GET_VENDORS_LIST_SUCCESS,
  RESET_MASTER_DATA_REDUCER,
} from "./actionTypes";
import { MasterDataActions, MasterDataState } from "./types";

const initialState: MasterDataState = {
  customerCodes: [],
  permissions: [],
  references: [],
  referenceNoOptions: [],
  customerDropdownBasedOnBillTo: [],
  masterCustomerDropdownList: [],
  vendorsList: [],
  vendorCodes: [],
  masterVendorDropdownList: [],
};

const reducers = (state = initialState, action: MasterDataActions) => {
  switch (action.type) {
    case GET_CUSTOMER_CODES_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_CUSTOMER_CODES_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        customerCodes: action?.payload?.customerCodes,
        customerDropdownBasedOnBillTo:
          action?.payload?.customerDropdownBasedOnBillTo,
        masterCustomerDropdownList: action?.payload?.masterCustomerDropdownList,
        error: null,
      };
    case GET_CUSTOMER_CODES_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    case GET_PERMISSIONS_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        permissions: action?.payload?.permissions,
        error: null,
      };
    case GET_PERMISSIONS_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
      case GET_REFERENCES_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_REFERENCE_NO_OPTIONS_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        referenceNoOptions: action?.payload?.referenceNoOptions,
        error: null,
      };
    case GET_REFERENCE_NO_OPTIONS_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
        case GET_REFERENCE_NO_OPTIONS_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_REFERENCES_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        references: action?.payload?.references,
        error: null,
      };
    case GET_REFERENCES_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    case RESET_MASTER_DATA_REDUCER:
      return initialState;
    case GET_VENDORS_LIST_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_VENDORS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        vendorsList: action.payload.vendorsList,
        vendorCodes: action.payload.vendorCodes,
        masterVendorDropdownList: action.payload.masterVendorDropdownList,
        error: null,
      };
    case GET_VENDORS_LIST_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    case GET_SERVICE_TYPE_LOOKUP_REQUEST:
      return {
        ...state,
        isLoadingScreen: true,
      };
    case GET_SERVICE_TYPE_LOOKUP_SUCCESS:
      return {
        ...state,
        isLoadingScreen: false,
        serviceTypeLookup: action?.payload?.serviceTypeLookup,
        error: null,
      };
    case GET_SERVICE_TYPE_LOOKUP_FAILURE:
      return {
        ...state,
        isLoadingScreen: false,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducers;
